import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class WitnessStackItem extends EquatableKeyStackItem {
    asWitness() {
        return this.value;
    }
}

//# sourceMappingURL=WitnessStackItem.js.map
